import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";

import { HeaderContext } from "config/contexts";
import { getLatestStories } from "../../../actions/latestStories";
import MiniStoryCard from "../MiniStoryCard";
import Spinner from "../Spinner";
import Ad from "components/Library/Ad";
import styles from "./LatestStories.css";

class LatestStories extends Component {
  componentDidMount() {
    if (!this.props.latestStories.results.length) {
      this.props.getLatestStories();
    }
  }

  renderPromo() {
    return (
      <div className={styles.promo}>
        <Ad adUnit="sidebar" slotSize={[300, 275]} />
      </div>
    );
  }

  render() {
    if (this.props.latestStories.results.length === 0) {
      if (this.props.latestStories.isLoading) {
        return <Spinner />;
      }
      return null;
    }

    const latestSorted = [...this.props.latestStories.results].sort((a, b) =>
      new Date(a.last_published || a.published_date).getTime() >
      new Date(b.last_published || b.published_date).getTime()
        ? -1
        : 1
    );

    return (
      <HeaderContext.Consumer>
        {headerLevels => {
          const HeadingTag = "h" + headerLevels.latestStoriesHeader;
          return (
            <div className={this.props.className}>
              <HeadingTag
                className={classNames(styles.heading, styles.hiddenLarge)}
              >
                Latest Stories
              </HeadingTag>
              <div className={styles.root}>
                <HeadingTag
                  className={classNames(styles.heading, styles.hiddenSmall)}
                >
                  Latest Stories
                </HeadingTag>
                {latestSorted.map((latest, i) => (
                  <div key={latest.id}>
                    <MiniStoryCard latest={latest} />
                    {i === 4 && this.renderPromo()}
                  </div>
                ))}
              </div>
            </div>
          );
        }}
      </HeaderContext.Consumer>
    );
  }
}

const mapStateToProps = state => {
  return {
    latestStories: state.latestStories,
  };
};

export default connect(
  mapStateToProps,
  { getLatestStories }
)(LatestStories);
